module.exports = __webpack_public_path__ + "static/media/4.e549b76b.mp3";